import { render } from "./RefundProductDetails.vue?vue&type=template&id=e91a3e48&scoped=true"
import script from "./RefundProductDetails.vue?vue&type=script&lang=js"
export * from "./RefundProductDetails.vue?vue&type=script&lang=js"

import "./RefundProductDetails.vue?vue&type=style&index=0&id=e91a3e48&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e91a3e48"]])

export default __exports__